import React, { memo } from 'react'
import { Link } from 'react-router-dom'
import { Stack } from '@fluentui/react/lib/Stack'
import { Icon } from '@fluentui/react/lib/Icon'
import Hallmark from '../../assets/hallmark.png'
import style from './style.module.css'

export default memo(() => {
    return (
        <Stack className={style.nav} horizontal horizontalAlign="center" verticalAlign="center">
            <Stack alignItems="center" horizontalAlign="center" tokens={{ childrenGap: 8 }}>
                <img src={Hallmark} alt="chevron" height="46" width="42" />
                <Stack.Item>
                    <header><Link to="/">surface live</Link></header>
                </Stack.Item>
                <span className={style.versionTag}>.NET 10 Version</span>
            </Stack>
        </Stack>
    )
})